import { ReportFilterType } from '@/utils/constants'
import { PrimitiveAtom, atom } from 'jotai'

export const visibleAlertsFilters = atom<Set<ReportFilterType>>(
  new Set<ReportFilterType>(),
) as PrimitiveAtom<Set<ReportFilterType>>
